// Pure helpers for the Store Analytics page: no network, no store, so they can
// be tested on their own.
import { storeRegion } from "../StoreRegions/functions";

// The region filter's entry for stores that have none assigned yet.
export const NO_REGION = "__no_region__";
export const NO_REGION_LABEL = "No region";

// Every region a store can be filtered by: the names /v1/regions returned plus
// any a store carries that the list lacks (the list may not have loaded, or
// may be out of date). Sorted by name, with "No region" last when some store
// has none.
export const regionOptions = (stores = [], regions = []) => {
  const names = new Set(regions.filter(Boolean));
  let unassigned = false;

  for (const store of stores) {
    const region = storeRegion(store);
    if (region) names.add(region);
    else unassigned = true;
  }

  const options = [...names]
    .sort((a, b) => a.localeCompare(b))
    .map((name) => ({ value: name, label: name }));

  return unassigned ? [...options, { value: NO_REGION, label: NO_REGION_LABEL }] : options;
};

// The stores in any of the picked regions; every store when none is picked.
export const storesInRegions = (stores = [], regions = []) => {
  if (regions.length === 0) return stores;
  const picked = new Set(regions);
  return stores.filter((store) => picked.has(storeRegion(store) || NO_REGION));
};

// The page of `rows` to show, 1-based, with the page clamped into range.
export const pageOf = (rows, page, pageSize) => {
  const pages = Math.max(1, Math.ceil(rows.length / pageSize));
  const current = Math.min(Math.max(1, page), pages);
  const start = (current - 1) * pageSize;
  return { rows: rows.slice(start, start + pageSize), page: current, pages, start };
};
